import { ITableConfigModel } from "../tsmodels/SharedModel";

export const defaultGridConfig: ITableConfigModel = {
  pagination: false,
  pageCount: 100,
  filters: true,
  sortable: false,
  resizable: false,
  draggable: false,
  reorder: false,
  pin: false,
  pinnedColumns: [],

  enableSummaryRows: false,

  enableExport: false,
  enableNestedTable: false,

  enableActionDropdown: false,
  enableActionFields: []
}

export const excludeRender = ['pageCount', 'pinnedColumns', 'enableActionFields']
